import { Component, ViewChild, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Video } from 'src/app/models/types/Product/Product.type';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrl: './video.component.scss',
  imports: [TranslateModule]
})
export class VideoComponent implements OnChanges {
  @Input('video') video!: Video | undefined;
  @ViewChild('videoElement') videoRef!: ElementRef;

  public showPlayButton = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.videoRef) {
      this.videoRef.nativeElement.load();
      this.showPlayButton = true;
    }
  }

  togglePlay() {
    this.videoRef.nativeElement.play();
    this.showPlayButton = false;
  }

  onVideoEnd() {
    this.showPlayButton = true;
  }

}
